var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "period",
      class: {
        "period--error": _vm.startError || _vm.endError,
      },
    },
    [
      _c("div", { staticClass: "period__wrapper" }, [
        _c(
          "div",
          {
            staticClass: "period-calendar",
            class: {
              "period-calendar--active": _vm.activeCalendar === "start",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "period-calendar-input",
                class: {
                  "period-calendar-input--required": _vm.startError,
                },
              },
              [
                _c("the-mask", {
                  staticClass: "period-calendar-input__field",
                  attrs: {
                    mask: "##.##.####",
                    type: "text",
                    placeholder: "00.00.0000",
                    masked: true,
                  },
                  model: {
                    value: _vm.start.input,
                    callback: function ($$v) {
                      _vm.$set(_vm.start, "input", $$v)
                    },
                    expression: "start.input",
                  },
                }),
                _c("div", { staticClass: "period-calendar-input__icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z",
                          stroke: "#8E9CBB",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M13 1V5",
                          stroke: "#8E9CBB",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M5 1V5",
                          stroke: "#8E9CBB",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "4",
                          y: "8",
                          width: "2",
                          height: "2",
                          fill: "#8E9CBB",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "4",
                          y: "12",
                          width: "2",
                          height: "2",
                          fill: "#8E9CBB",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "8",
                          y: "8",
                          width: "2",
                          height: "2",
                          fill: "#8E9CBB",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "8",
                          y: "12",
                          width: "2",
                          height: "2",
                          fill: "#8E9CBB",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "12",
                          y: "8",
                          width: "2",
                          height: "2",
                          fill: "#8E9CBB",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "12",
                          y: "12",
                          width: "2",
                          height: "2",
                          fill: "#8E9CBB",
                        },
                      }),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _vm.startError || _vm.endError
              ? _c(
                  "div",
                  { staticClass: "period-calendar__error" },
                  [
                    _vm.startError
                      ? _c("error-feedback", {
                          attrs: { text: _vm.startError.text },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "period-calendar__picker" },
              [
                _c("datepicker", {
                  attrs: {
                    inline: true,
                    language: _vm.ru,
                    "full-month-name": true,
                    "monday-first": true,
                    highlighted: {
                      from: _vm.start.highlighted,
                      to: _vm.end.highlighted,
                    },
                    "open-date": _vm.startMonth,
                    value: _vm.start.selected,
                    "calendar-class":
                      "c-input-container-calendar c-input-container-calendar_period",
                  },
                  on: {
                    changedMonth: _vm.changedStartMonth,
                    selected: _vm.periodSelectStartDay,
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "period-calendar",
            class: {
              "period-calendar--active": _vm.activeCalendar === "end",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "period-calendar-input",
                class: {
                  "period-calendar-input--required": _vm.endError,
                },
              },
              [
                _c("the-mask", {
                  staticClass: "period-calendar-input__field",
                  attrs: {
                    mask: "##.##.####",
                    type: "text",
                    placeholder: "00.00.0000",
                    masked: true,
                  },
                  model: {
                    value: _vm.end.input,
                    callback: function ($$v) {
                      _vm.$set(_vm.end, "input", $$v)
                    },
                    expression: "end.input",
                  },
                }),
                _c("div", { staticClass: "period-calendar-input__icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z",
                          stroke: "#8E9CBB",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M13 1V5",
                          stroke: "#8E9CBB",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M5 1V5",
                          stroke: "#8E9CBB",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "4",
                          y: "8",
                          width: "2",
                          height: "2",
                          fill: "#8E9CBB",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "4",
                          y: "12",
                          width: "2",
                          height: "2",
                          fill: "#8E9CBB",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "8",
                          y: "8",
                          width: "2",
                          height: "2",
                          fill: "#8E9CBB",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "8",
                          y: "12",
                          width: "2",
                          height: "2",
                          fill: "#8E9CBB",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "12",
                          y: "8",
                          width: "2",
                          height: "2",
                          fill: "#8E9CBB",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "12",
                          y: "12",
                          width: "2",
                          height: "2",
                          fill: "#8E9CBB",
                        },
                      }),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _vm.startError || _vm.endError
              ? _c(
                  "div",
                  { staticClass: "period-calendar__error" },
                  [
                    _vm.endError
                      ? _c("error-feedback", {
                          attrs: { text: _vm.endError.text },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "period-calendar__picker" },
              [
                _c("datepicker", {
                  attrs: {
                    inline: true,
                    language: _vm.ru,
                    "full-month-name": true,
                    "monday-first": true,
                    highlighted: {
                      from: _vm.start.highlighted,
                      to: _vm.end.highlighted,
                    },
                    "open-date": _vm.endMonth,
                    value: _vm.end.selected,
                    "calendar-class":
                      "c-input-container-calendar c-input-container-calendar_period",
                  },
                  on: {
                    changedMonth: _vm.changedEndMonth,
                    selected: _vm.periodSelectEndDay,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
      _c("div", { staticClass: "period-switcher" }, [
        _c(
          "div",
          {
            staticClass: "period-switcher__item",
            class: {
              "period-switcher__item--active": _vm.activeCalendar === "start",
            },
            on: {
              click: function ($event) {
                _vm.activeCalendar = "start"
              },
            },
          },
          [_c("span", [_vm._v("Начало периода")])]
        ),
        _c(
          "div",
          {
            staticClass: "period-switcher__item",
            class: {
              "period-switcher__item--active": _vm.activeCalendar === "end",
            },
            on: {
              click: function ($event) {
                _vm.activeCalendar = "end"
              },
            },
          },
          [_c("span", [_vm._v("Конец периода")])]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }